<template>
  <div id="offers">
    <header-o :model="headerData"></header-o>
    <div class="margin-vertical-10" :style="[isGamification ? {'margin-top': '-70px'} : {'margin-top': '-80px'}]">
      <div v-if="allOffers.length" v-for="offer in allOffers">
        <div class="offer-card bg-light radius-5 padding-horizontal-20 margin-bottom-10 pos-rel box-shadow pointer"
             @click="redirectTo('offers/'+offer.id)" v-if="offer.offer_type_code.includes('checkin')">
          <div class="currency-type">
            <img class="small-icon" v-if="offer.currency_icon_url" :src="offer.currency_icon_url">
            <div class="text-small text-uppercase" style="padding-top: 5px">Earn {{offer.currency_label}}</div>
          </div>
          <img class="medium-icon padding-top-5 margin-bottom-10" src="@/assets/check-in.svg">
          <div class="padding-vertical-10">
            <div class="margin-bottom-10 padding-vertical-10 font-extra-bold text-large">{{stripHTML(offer.title)}}</div>
            <div class="margin-bottom-20 padding-vertical-10 desc">{{stripHTML(offer.description)}}</div>
          </div>
          <div style="z-index: 100;">
            <milestone :model="offer" @msData="getMsData"></milestone>
          </div>

          <div v-if="!offer.event_id" style="padding-top: 7px">
            <button class="custom-button small text-light padding-10 radius-5 text-large pointer" :style="{background: bgTheme}" v-if="offer.checked_in">CHECKED IN</button>
            <button class="custom-button small text-light padding-10 radius-5 text-large pointer" :style="{background: bgTheme}" @click.stop.prevent="dailyCheckin(offer)" v-else>CHECK IN</button>
          </div>
        </div>

        <div class="offer-card bg-light radius-5 padding-20 margin-bottom-10 pos-rel box-shadow pointer"

             @click="redirectTo('offers/'+offer.id)" v-if="offer.offer_type_code.includes('invite') && !offer.show_banner">
          <div class="currency-type">
            <img class="small-icon" v-if="offer.currency_icon_url" :src="offer.currency_icon_url">
            <div class="text-small text-capitalize" style="padding-top: 5px">Earn {{offer.currency_label}}</div>
          </div>
          <img class="medium-icon margin-right-5 margin-bottom-10" src="@/assets/invite.svg">
          <div class="margin-bottom-10 padding-vertical-10 font-extra-bold text-large">{{stripHTML(offer.title)}}</div>
          <div class="margin-bottom-20 padding-vertical-10 desc">{{stripHTML(offer.description)}}</div>
          <button class="custom-button small text-light padding-10 radius-5 margin-bottom-5 text-large pointer text-uppercase" :style="{background: bgTheme}" @click="" style="padding-top: 10px">Invite</button>
          <div class="align-hor center-ver center-hor" v-if="isGamification">
            <img class="extra-small-icon margin-right-5" v-if="userCurrLevelIcon" :src="userCurrLevelIcon">
            <img class="extra-small-icon margin-right-5" v-else src="@/assets/medal.svg">
            <div class="text-smaller">Your current Level: {{offer.current_level}}</div>
          </div>
        </div>

        <div class="offer-card bg-light radius-5 margin-bottom-10 pos-rel box-shadow pointer"

             @click="redirectTo('offers/'+offer.id)" v-if="offer.offer_type_code.includes('invite') && offer.show_banner">
          <div>
            <img width="100%;" style="border-radius: 5px" :src="offer.image_url">
          </div>
        </div>


        <div class="offer-card bg-light radius-5 padding-15 margin-bottom-10 pos-rel box-shadow pointer"

             v-if="offer.offer_type_code.includes('daily') && !offer.show_banner"  @click="challengeRedirect(offer)">
          <div class="align-ver center-ver space-between">
            <div class="margin-right-10">
              <img class="semi-medium-icon margin-bottom-10" src="@/assets/Challenges.svg">
            </div>
            <div class="text-center margin-right-10 flex-09">
              <div class="margin-bottom-5 font-extra-bold text-medium padding-vertical-5">{{stripHTML(offer.title)}}</div>
              <div class="margin-bottom-20" style="margin-bottom: 20px">{{stripHTML(offer.description)}}</div>
            </div>
            <div class="padding-top-5">
              <button class="custom-button small text-light padding-10 radius-5 text-large pointer text-uppercase"
                      v-if="offer.button_text.length>0"
                      style="padding-top: 7px; min-width:90px"
                      @click="challengeRedirect(offer)"
                      :style="{background: bgTheme}">{{offer.button_text}}</button>

            </div>
<!--            <div class="align-ver center-ver">
              <div class="align-hor center-ver">
                <div><img class="small-icon margin-right-5" :src="offer.currency_icon_url"></div>
                <div>{{offer.currency_label}}</div>
              </div>
              <div class="end-align-self" v-if="(offer.min_reward > 0 && offer.max_reward > 0) || offer.max_reward > 0">
                <button class="custom-button small text-small padding-0510 radius-5 no-wrap bg-light text-large min-w60 pointer" :style="{border: '1px solid '+bgTheme, background: '#fff'}" v-if="(offer.min_reward == 0 && offer.max_reward > 0)">Upto {{formatReward(offer.currency_label, offer.max_reward, false)}}</button>
                <button class="custom-button small text-small padding-0510 radius-5 no-wrap bg-light text-large min-w60 pointer" :style="{border: '1px solid '+bgTheme, background: '#fff'}" v-else-if="(offer.min_reward > 0 && offer.max_reward > 0 && (offer.min_reward == offer.max_reward))">{{formatReward(offer.currency_label, offer.max_reward, false)}}</button>
                <button class="custom-button small text-small padding-0510 radius-5 no-wrap bg-light text-large min-w60 pointer" :style="{border: '1px solid '+bgTheme, background: '#fff'}" v-else>{{formatReward(offer.currency_label, offer.min_reward, false)}} to {{formatReward(offer.currency_label, offer.max_reward, false)}}</button>
              </div>
            </div>-->
          </div>
        </div>

        <div class="offer-card bg-light radius-5 margin-bottom-10 spin-wheel pos-rel box-shadow pointer"

             @click="challengeRedirect(offer)"
             v-else-if="offer.offer_type_code.includes('daily') && offer.show_banner && offer.id != 74">
          <div>
            <img width="100%;"@click="challengeRedirect(offer)" style="border-radius: 5px" :src="offer.image_url">
          </div>
        </div>

        <div class="offer-card bg-light radius-5 padding-20 margin-bottom-10 pos-rel box-shadow pointer"
             v-if="offer.offer_type_code.includes('game')" @click="redirectTo('game-zone')"
              >
          <div class="currency-type" v-if="offer.currencies.length > 0">
            <div class="align-hor center-ver center-hor margin-bottom-5">
              <img class="small-icon" :class="offer.currencies.length > 1 ? 'margin-right-5' : ''" :src="o.icon_url" v-for="o in offer.currencies">
            </div>
            <div class="text-small text-uppercase padding-top-5">Earn {{getCurrencyLabels(offer.currencies)}}</div>
          </div>
          <img class="medium-icon margin-right-5 margin-bottom-10" src="@/assets/game-zone.svg">
          <div class="padding-vertical-10">
            <div class="margin-bottom-10 font-extra-bold text-large">{{stripHTML(offer.title)}}</div>
            <div class="margin-bottom-20" style="margin-bottom: 20px">{{stripHTML(offer.description)}}</div>
          </div>
          <button class="custom-button small text-light padding-10 radius-5 text-large pointer text-uppercase" :style="{background: bgTheme}" style="padding-top: 10px">Play</button>
        </div>

        <!-- <div class="offer-card bg-light radius-5 padding-20 margin-bottom-10 pos-rel box-shadow pointer" v-if="offer.offer_type_code.includes('quiz')" @click="quizList()"> -->

        <div class="offer-card bg-light radius-5 padding-20 margin-bottom-10 pos-rel box-shadow pointer"

             v-if="offer.offer_type_code.includes('quiz') && !offer.show_banner" @click="redirectTo('quiz-zone')">
          <div class="currency-type" v-if="offer.currencies.length > 0">
            <div class="align-hor center-ver center-hor margin-bottom-5">
              <img class="small-icon" :class="offer.currencies.length > 1 ? 'margin-right-5' : ''" :src="o.icon_url" v-for="o in offer.currencies">
            </div>
            <div class="text-small text-uppercase" style="padding-top: 5px">Earn {{getCurrencyLabels(offer.currencies)}}</div>
          </div>
          <img class="medium-icon margin-right-5 margin-bottom-10" src="@/assets/quiz-zone.svg">
          <div class="padding-vertical-10">
            <div class="margin-bottom-10 font-bold text-large">{{stripHTML(offer.title)}}</div>
            <div class="margin-bottom-20" style="margin-bottom: 20px">{{stripHTML(offer.description)}}</div>
          </div>
          <button class="custom-button small text-light padding-10 radius-5 text-large pointer text-uppercase"
                  :style="{background: bgTheme}" style="padding-top: 10px">Play</button>
        </div>

        <div class="offer-card bg-light radius-5 margin-bottom-10 pos-rel box-shadow pointer"

             @click="redirectTo('quiz-zone')" v-else-if="offer.offer_type_code.includes('quiz') && offer.show_banner">
          <div>
            <img width="100%" :src="offer.image_url" style="border-radius: 5px">
          </div>
        </div>

        <!--Stamp collection offer card -->
        <div class="offer-card bg-light radius-5 padding-20 margin-bottom-10 pos-rel box-shadow pointer"
             v-if="offer.offer_type_code.includes('stamp')" @click="redirectTo('stamp-campaign')">
          <div class="currency-type" v-if="offer.currencies">
            <div class="align-hor center-ver center-hor margin-bottom-5">
              <img class="small-icon" :class="offer.currencies.length > 1 ? 'margin-right-5' : ''" :src="o.icon_url" v-for="o in offer.currencies">
            </div>
            <div class="text-small text-uppercase" style="padding-top: 5px">Earn {{getCurrencyLabels(offer.currencies)}}</div>
          </div>
          <img class="medium-icon margin-right-5 margin-bottom-10" src="@/assets/quiz-zone.svg">
          <div class="padding-vertical-10">
            <div class="margin-bottom-10 font-extra-bold text-large">{{stripHTML(offer.title)}}</div>
            <div class="margin-bottom-20" style="margin-bottom: 20px">{{stripHTML(offer.description)}}</div>
          </div>
          <button class="custom-button small text-light padding-10 radius-5 text-large pointer text-uppercase" :style="{background: bgTheme}" style="padding-top: 10px">Play</button>
        </div>


      </div>

      <div v-if="msData && msData.show_popup"><mile-stone-popper :model="msData"></mile-stone-popper></div>

      <div class="margin-bottom-20" v-if="allOffers.length == 0 && showShimmer">
        <div class="align-hor space-between margin-bottom-20" v-for="$i in 1">
          <div class="wrapper" :class="$j < 2 ? 'margin-right-10' : ''" v-for="$j in 1">
            <div :style="windowWidth < 511?'min-height:140px' : 'min-height:130px'"
                 class="comment offer-shimmer shimmer-box animate bg-light-grey" v-for="$k in 3"></div>
          </div>
        </div>
      </div>
    </div>
      <div class="bg-light bottom-radius-5 padding-20 margin-bottom-10 pos-rel box-shadow align-ver center-hor center-ver" style="min-height: 80vh" v-if="allOffers && allOffers.length == 0 && !showShimmer">
        <img class="extra-large-icon margin-bottom-20" src="@/assets/no-data.svg">
        <div>Nothing to show</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  import OverlapHeader from '@/components/overlapped-header'
  import Milestone from '@/components/milestone'
  import MilestoneDetailPopup from '@/components/milestone-detail-popup';
  import ScratchCard from '@/components/scratch-card'
  export default {
    mixins: [globals],
    components: {
      'header-o': OverlapHeader,
      'milestone': Milestone,
      'scratch-card': ScratchCard,
      'mile-stone-popper': MilestoneDetailPopup
    },
    data() {
      return {
        headerData: {
          onlyHeader: false,
          rewards: false
        },
        isCheckIn: false,
        all_offers: [],
        hasGamification: false,
        is_shimmer: true,
        msData: null
      }
    },
    computed: {
      allOffers: function() {
        return this.all_offers;
      },
      showShimmer: function() {
        return this.is_shimmer;
      },
      milestoneShown: function (){
        return this.$store.state.show_mile_stone_modal;
      }
    },
    beforeMount() {
      var self = this;
      if (window.addEventListener) {
              window.addEventListener("message", self.handleSDKMessage, false);
      } else {
              window.attachEvent("onmessage", self.handleSDKMessage);
      }
      this.loadDataFromCookie();
      this.getFlyyAppinfo();
    },
    methods: {
      handleSDKMessage(event) {

        // if (event.origin !== "https://web-sdk.theflyy.com")
        //     return;

        var data = null;
        try{
          data = JSON.parse(event.data);
        } catch (e){}
        if (data != null) {
          var headers = {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "X-Package-Name": data["package_name"],
            "X-SDK-Version-Code": data["sdk_version_code"],
            "X-SDK-Version-Name": data["sdk_version_name"],
            "X-App-Version-Code": data["app_version_code"],
            "X-App-Version-Name": data["app_version_name"],
            "X-Android-Id": data["android_id"],
            "X-GAID": data["gaid"],
            "X-App-Data": data["app_data"],
            "X-User-Token": data["user_token"],
            "X-Key": (data["api_key"] || data["partner_id"]),
            "X-Token": data["ext_user_token"],
            "X-User-Segment": data["segment_id"]
          };
          if(data["Environment"]) {
            this.$store.state.environment = data["Environment"];
          } else {
            this.$store.state.environment = data["environment"];
          }
          if(data["theme_color_primary"]) {
            this.$store.state.bg_theme = data["theme_color_primary"];
          }
          if(data["ext_uid"]) {
            this.$store.state.user.ext_uid = data["ext_uid"];
          } else if(data["user_token"]){
            this.$store.state.user.ext_uid = data["user_token"];
          }
          this.$store.state.partner = (data["api_key"] || data["partner_id"]);
          this.$store.dispatch('setHeaders', headers)
          if (data["isNotification"]) {
            this.$router.push("rewards");
          } else {
            this.getFlyyAppinfo()
          }
        }
      },
      goToDetailsPage(id, params) {
        this.$router.push({path: '/offers/'+id, query: params});
      },
      getFlyyAppinfo() {
        var self  = this;
        if(self.hasPartnerToken){
          axios.all([this.getAppInfo()])
          .then(axios.spread((resp) => {
            if(resp.status == 200) {
              var data = resp.data;
              if(data.success) {
                self.getBasicAppInfo();
                self.all_offers = data.info.offers;
                self.$store.state.user.userName = data.info.user_name || "User";

                self.$store.state.user.show_currency_name = data.info.offers_show_currency_name;
                self.$store.state.user.show_currency_list = data.info.offers_show_currency_list;
                self.$store.state.user.show_action_button = true;

                if(self.all_offers && self.all_offers.length > 0) {
                  var tempOfferCheck = self.all_offers.filter((o) => {return o.offer_type_code.includes("checkin")});
                  if(tempOfferCheck.length > 0) {
                    self.isCheckIn = true;
                    self.$store.state.user.milestones = tempOfferCheck[0].milestones;
                    self.all_offers.forEach((offer)=>
                    {
                        offer.mile_stones = this.formatUserCheckins(offer);
                    });
                  } else {
                    self.isCheckIn = true;
                  }
                  self.$store.state.allOffersList = self.all_offers;
                  if(self.allOffers && self.allOffers.length > 0) {
                    var tempOfferCheck = self.allOffers.filter((o) => {return o.offer_type_code.includes("checkin")})
                    if(tempOfferCheck.length > 0) {
                      self.isCheckIn = true;
                      self.$store.state.user.milestones = tempOfferCheck[0].milestones;
                    } else {
                      self.isCheckIn = true;
                    }
                    var tempOfferGam = self.all_offers.filter((o) => {return o.offer_type_code.includes("gamification")})
                    self.$store.state.hasGamification = (tempOfferGam.length > 0) ? true : false;
                    self.$store.state.user.currLevel = (tempOfferGam.length > 0) ? tempOfferGam[0].current_level : "";
                    self.$store.state.user.currLevelIcon = (tempOfferGam.length > 0) ? tempOfferGam[0].current_level_icon_url : "";
                  }
                }
                this.is_shimmer = false;
              } else {
                this.is_shimmer = false;
              }
            } else {
              this.is_shimmer = false;
            }
          })).catch((err) => {})
        } else {
          console.log("No partner token found!!!");
        }
      },
      getMsData(ms){
        this.msData = ms;
      }
    },
    created() {
      var store_state = this.$store.state;
      store_state.showHeader = false;
      store_state.showWallet = false;
      store_state.showHistory = false;
      store_state.user.headerBalance.show = false;
      store_state.headTitle = "Offers";
      document.documentElement.style.setProperty('--bg-color', this.$store.state.bg_theme);
      document.documentElement.style.setProperty('--bg-light-color',this.$store.state.bg_theme+'59');
    }
  }
</script>
<style>
  .currency-type {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .currency-type.dummy {
    right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/offers.vue